// import something here
import { boot } from 'quasar/wrappers';
import { bus } from '@/util/event-bus';

export default boot(async({ Vue }) => {
   Vue.prototype.$bus = bus;
});
